import type React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import { Tooltip } from '@vlabs/uikit';
import type { WithClassNameProp } from '@vlabs/uikit/types';
import cn from 'classnames';

import st from './FormFieldGroup.module.sass';

interface FormFieldGroupProps extends WithClassNameProp {
  children: React.ReactNode;
}

interface FormFieldGroupItemProps extends WithClassNameProp {
  label: React.ReactNode;
  /** Подсказка-тултип рядом с лейблом. */
  tooltip?: string;
  /** Обязательное поле — красная звёздочка вплотную к тексту лейбла. */
  required?: boolean;
  children?: React.ReactNode;
}

function FormFieldGroupRoot({ children, className }: FormFieldGroupProps): React.JSX.Element {
  return <div className={cn(st.Root, className)}>{children}</div>;
}

function FormFieldGroupItem({
  label,
  tooltip = undefined,
  required = false,
  children = undefined,
  className,
}: FormFieldGroupItemProps): React.JSX.Element {
  return (
    <div className={cn(st.Field, className)}>
      <span className={st.Label}>
        <span className={st.LabelText}>
          {label}
          {!!required && <span className={st.Required}>*</span>}
        </span>
        {!!tooltip && (
          <Tooltip
            tooltipContent={tooltip}
            tooltipProps={{ place: 'right' }}
          >
            <InfoCircleIcon className={st.LabelIcon} />
          </Tooltip>
        )}
      </span>
      <div className={st.Control}>{children}</div>
    </div>
  );
}

const FormFieldGroup = Object.assign(FormFieldGroupRoot, { Item: FormFieldGroupItem });

export { FormFieldGroup };
